import { Directive, HostBinding } from '@angular/core';
import { clsx } from 'clsx';

@Directive({
  selector: '[sbDivider], [sb-divider], sb-divider',
  exportAs: 'sbDivider',
  standalone: true,
})
export class DividerDirective {
  @HostBinding('class')
  classList = clsx('block overflow-hidden border-0 border-t border-solid border-default');
}
